import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";
import { editEventRoute } from "../place/edit/route";

export const myWorkOppsRoute: RouteConfig<'with-page'> = {
    name: 'My Events',
    path: '/work-opps/my-events',
    page: lazy(() => import('.')),
    context: 'member',
    flags: ['member-route'],
    permissions: ['workOps'],
    dynamicChildren: [
        editEventRoute
    ]
}
